import React from "react"

import ImageArrowRight from "./imageArrowRight"

export const arrowLeft = (
  <div className="arrowContainer arrowLeft">
    <div className="triangleTopLeft"></div>
    <div className="triangleBottomLeft"></div>
  </div>
)

// export const arrowRight = (
//   <div className="arrowContainer arrowRight">
//     <div className="triangleTopRight"></div>
//     <div className="triangleBottomRight"></div>
//   </div>
// )

export const arrowRight = (
  <div className="arrowContainer arrowRight">
    <ImageArrowRight />
  </div>
)
